import { Component } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation',
  template: `
    <app-navigation></app-navigation>
    <router-outlet></router-outlet>
  `,
})
export class CompatNavigationComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/compat/compat-navigation.component.ts